import PageHero from "@/components/PageHero";
import ArticleCard from "@/components/ArticleCard";
import { useArticles } from "@/content/ContentProvider";
import LocalizedLink from "@/components/LocalizedLink";
import { pickLang, useLanguage } from "@/i18n/LanguageContext";

const C = {
  ar: {
    eyebrow: "المقالات",
    title: "محتوى عربي مبسّط عن الذكاء الاصطناعي",
    lead: "أفكار وشروحات وأدلّة عملية تخدم الطالب والباحث والمعلّم، في البحث والدراسة والحياة اليومية. ننشر بتدرّج حتّى يبقى المحتوى مركّزًا ومفيدًا.",
    catsNote: "مواضيع النشر المرتقبة. سيتم تفعيل التصفية والبحث في مرحلة لاحقة.",
    emptyEyebrow: "قريبًا",
    emptyTitle: "المقالات قيد التحضير",
    emptyBody: "نعمل حاليًا على إعداد محتوى عربي مبسّط حول أدوات الذكاء الاصطناعي واستخداماتها العملية في الدراسة والبحث والحياة اليومية.",
    emptyCta: "استكشف دليل الأدوات في الوقت نفسه",
  },
  en: {
    eyebrow: "Articles",
    title: "Simplified Arabic-first content on AI",
    lead: "Ideas, explainers, and practical guides for students, researchers, and educators — across research, study, and daily life. We publish at a deliberate pace to keep every piece focused and useful.",
    catsNote: "Upcoming topic areas. Filtering and search will be enabled in a later phase.",
    emptyEyebrow: "Coming soon",
    emptyTitle: "Articles in preparation",
    emptyBody: "We're currently preparing simplified content about AI tools and their practical uses in study, research, and daily life.",
    emptyCta: "Explore the tools directory in the meantime",
  },
};

export default function Articles() {
  const { lang } = useLanguage();
  const c = C[lang];
  const { ARTICLES, ARTICLE_CATEGORIES } = useArticles();
  const hasArticles = ARTICLES.length > 0;

  return (
    <>
      <PageHero eyebrow={c.eyebrow} title={c.title} lead={c.lead} />
      <section className="sas-section-sm border-b border-[color:var(--sas-line)]" data-testid="articles-categories">
        <div className="sas-container">
          <div className="flex flex-wrap gap-2">
            {ARTICLE_CATEGORIES.map((x) => (
              <span key={x.id} className="sas-chip sas-chip-neutral">{pickLang(x.label, lang)}</span>
            ))}
          </div>
          <p className="text-xs text-[color:var(--sas-ink-2)] mt-4">{c.catsNote}</p>
        </div>
      </section>
      <section className="sas-section" data-testid="articles-list">
        <div className="sas-container">
          {hasArticles ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-14 gap-x-8">
              {ARTICLES.map((a) => <ArticleCard key={a.slug} article={a} />)}
            </div>
          ) : (
            <div className="border border-dashed border-[color:var(--sas-line)] rounded-xl py-16 px-6 text-center" data-testid="articles-empty">
              <div className="sas-eyebrow mb-3">{c.emptyEyebrow}</div>
              <h2 className="sas-h2">{c.emptyTitle}</h2>
              <p className="sas-body mt-3 max-w-xl mx-auto">{c.emptyBody}</p>
              <div className="mt-6">
                <LocalizedLink to="/tools" className="sas-btn sas-btn-ghost">{c.emptyCta}</LocalizedLink>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
